<template>
  <div class="input-mask-proxy" :class="{ 'input-mask-proxy__prefix': prefix }" aria-hidden="true">
    <span class="input-group--text-field__prefix" v-if="prefix">{{ prefix }}</span>
    {{ output }}
    <span class="input-group--text-field__prefix" v-if="suffix">{{ suffix }}</span>
  </div>
</template>

<script>
import InputMaskTypes from '@/directives/input-mask/input-mask-types';

export default {
  props: {
    inputValue: {
      type: [String, Number],
      default: '',
    },
    maskType: {
      type: String,
      required: true,
    },
    prefix: {
      type: String,
      default: '',
    },
    suffix: {
      type: String,
      default: '',
    },
  },
  computed: {
    output() {
      if (
        this.inputValue !== null &&
        typeof this.inputValue !== 'undefined' &&
        InputMaskTypes[this.maskType]
      ) {
        return InputMaskTypes[this.maskType].construct(this.inputValue);
      }
    },
  },
};
</script>